import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionOverStateComponent } from './components/session-over-state/session-over-state.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthlayoutComponent } from './layouts/authlayout/authlayout.component';
import { ApphomelayoutComponent } from './layouts/apphomelayout/apphomelayout.component';
import { AppinnerlayoutComponent } from './layouts/appinnerlayout/appinnerlayout.component';
import { SigninComponent } from './pages/signin/signin.component';
import { ForgetpasswordComponent } from './pages/forgetpassword/forgetpassword.component';
import { ResetpasswordComponent } from './pages/resetpassword/resetpassword.component';
import { VerifyComponent } from './layouts/authlayout/verify/verify.component';
import { FooterinfoComponent } from './components/footerinfo/footerinfo.component';
import { HeaderbackComponent } from './components/headerback/headerback.component';
import { PagenotfoundComponent } from './pages/pagenotfound/pagenotfound.component';
import { PagenotauthorizedComponent } from './pages/pagenotauthorized/pagenotauthorized.component';
import { TenantsCreatePageComponent } from './pages/tenants-create-page/tenants-create-page.component';
import { ProfileEditComponent } from './pages/profile-edit/profile-edit.component';
import { UsersCreatePageComponent } from './pages/users-create-page/users-create-page.component';
import { HeadermenuComponent } from './components/headermenu/headermenu.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { TenantsPageComponent } from './pages/tenants-page/tenants-page.component';
import { UsersListPageComponent } from './pages/users-list-page/users-list-page.component';
import { ImpersonationModalComponent } from './components/impersonation-modal/impersonation-modal.component';
import { TenantFormComponent } from './components/tenant-form/tenant-form.component';
import { UserBasicInfoFormComponent } from './components/user-basic-info-form/user-basic-info-form.component';
import { UserHeaderImageComponent } from './components/user-header-image/user-header-image.component';
import { TenantListComponent } from './components/tenant-list/tenant-list.component';
import { UserCardComponent } from './components/user-card/user-card.component';
import { UsersListComponent } from './components/users-list/users-list.component';
import { SalesProfileQuestionnaireComponent } from './components/sales-profile-questionnaire/sales-profile-questionnaire.component';
import { SalesProfileSummaryCardComponent } from './components/sales-profile-summary-card/sales-profile-summary-card.component';
import { LogoComponent } from './components/logo/logo.component';
import { SharedModule } from '../shared/shared.module';
import { OfflineLabelComponent } from './components/offline-label/offline-label.component';
import { PwaInstallButtonComponent } from './components/pwa-install-button/pwa-install-button.component';
import { UnsyncedChangesComponent } from './components/unsynced-changes/unsynced-changes.component';
import { ChangePasswordFormComponent } from './components/change-password-form/change-password-form.component';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { HomeMenuGridComponent } from './pages/homepage/home-menu-grid/home-menu-grid.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Office365authComponent } from './components/office365auth/office365auth.component';
import { MenuComponent } from './components/menu/menu.component';
import { DocumentPostComponent } from './components/document-post/document-post.component';
import { MenuUserCardComponent } from './components/menuuser-card/menuuser-card.component';
import { FolderPostComponent } from './components/folder-post/folder-post.component';
import { FolderpageComponent } from './pages/folderpage/folderpage.component';
import { DocumenttypePostComponent } from './components/documenttype-post/documenttype-post.component';
import { DocumenttypeEditpageComponent } from './pages/documenttype-editpage/documenttype-editpage.component';
import { DocumentEditpageComponent } from './pages/document-editpage/document-editpage.component';
import { FolderEditpageComponent } from './pages/folder-editpage/folder-editpage.component';
import { FolderEditformComponent } from './components/folder-editform/folder-editform.component';
import { DocumentEditformComponent } from './components/document-editform/document-editform.component';
import { DocumenttypeEditformComponent } from './components/documenttype-editform/documenttype-editform.component';
import { AdminDocumentPageComponent } from './pages/admin-document-page/admin-document-page.component';
import { DocumenttypeFromSideMenuComponent } from './components/documenttype-from-SideMenu/documenttype-from-SideMenu.component';
// import { MapsPageComponent } from './pages/maps-page/maps-page.component';
// import { AgmCoreModule } from '@agm/core';
import { AdminCompaniesPageComponent } from './pages/admin-companies-page/admin-companies-page.component';
import { CompaniesEditformComponent } from './components/companies-editform/companies-editform.component';
import { ClientsCreatePageComponent } from './pages/clients-create-page/clients-create-page.component';
import { AdminLocationsPageComponent } from './pages/admin-locations-page/admin-locations-page.component';
import { AdminContactsPageComponent } from './pages/admin-contacts-page/admin-contacts-page.component';
import { ContactsCreatePageComponent } from './pages/contacts-create-page/contacts-create-page.component';
// import { LocationsCreatePageComponent } from './pages/locations-create-page/locations-create-page.component';
import { LocationsEditformComponent } from './components/locations-editform/locations-editform.component';
import { ContactsEditformComponent } from './components/contacts-editform/contacts-editform.component';
import { ActiveTenantPageComponent } from './pages/active-tenant-page/active-tenant-page.component';
import { TranslocoRootModule } from 'app/transloco-root.module';
import { NotificationsListComponent } from './pages/notifications-list/notifications-list.component';
import { TenantInfoPageComponent } from './pages/tenant-info-page/tenant-info-page.component';
import { TenantInfoComponentComponent } from './components/tenant-info-component/tenant-info-component.component';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { TenantHtmlFormComponent } from './components/tenant-html-form/tenant-html-form.component';
import { TenantEdithtmlPageComponent } from './pages/tenant-edithtml-page/tenant-edithtml-page.component';
import { BaseModule } from '../base/base.module';
import { CoreRoutingModule } from 'app/routing/core-routing.module';
import { SidebarItemsComponent } from './components/sidebar/sidebarItems/sidebarItems.component';
import { TenantMsGraphEditPageComponent } from './pages/tenant-ms-graph-edit-page/tenant-ms-graph-edit-page.component';
import { TenantMsGraphEditFormComponent } from './components/tenant-ms-graph-edit-form/tenant-ms-graph-edit-form.component';
import { ButtonModule } from 'primeng/button';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SpinnerComponent } from './components/loadingSpiner/spinnerComponent';
import { TenantDescriptionFormComponent } from './components/tenant-description-form/tenant-description-form.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { CustomColorIconComponent } from '../shared/components/custom-color-icon/custom-color-icon.component';
import { TenantTagsComponent } from './components/tenant-tags/tenant-tags.component';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TenantEmailsListPageComponent } from './pages/tenants-emails-list-page/tenant-email-list-page.component';
import { TenantFoldersComponent } from './components/tenant-folders/tenant-folders.component';
import { TenantTeamsComponent } from './components/tenant-teams/tenant-teams.component';
import { TenantDepartmentsComponent } from './components/tenant-departments/tenant-departments.component';
import { TenantChecklistPageComponent } from './pages/tenant-checklist-page/tenant-checklist-page.component';
import { DialogModule } from 'primeng/dialog';
import { ChecklistModalComponent } from './components/checklist-modal/checklist-modal.component';
import { TenantEmailTemplateComponent } from './components/tenant-email-template/tenant-email-template.component';
import { TenantQuestionnaireComponent } from './components/tenant-questionnaire/tenant-questionnaire.component';
import { TreeModule } from 'primeng/tree';
import { Checkbox } from 'primeng/checkbox';
import { TenantSpDescriptionComponent } from './pages/tenant-sp-description/tenant-sp-description.component';
import { IgntrFlameComponent, IgntrIconComponent } from 'app/shared/igntr';
import { DashboardCardComponent } from './pages/homepage/dashboard/dashboard-card.component';
import { DashboardHeroComponent } from './pages/homepage/dashboard/hero.component';
import { DashboardTodayAgendaComponent } from './pages/homepage/dashboard/today-agenda.component';
import { DashboardTasksSummaryComponent } from './pages/homepage/dashboard/tasks-summary.component';
import { DashboardNewsFeedComponent } from './pages/homepage/dashboard/news-feed.component';
import { DashboardContinueLearningComponent } from './pages/homepage/dashboard/continue-learning.component';
import { DashboardFeaturedToolsComponent } from './pages/homepage/dashboard/featured-tools.component';
import { DashboardGamificationComponent } from './pages/homepage/dashboard/gamification.component';
import { DashboardHeaderComponent } from './pages/homepage/dashboard/page-header.component';
import { BreadcrumbComponent } from '../shared/components/breadcrumb/breadcrumb.component';
import { GamificationToastComponent } from '../gamification/components/gamification-toast/gamification-toast.component';
import { PageHeroComponent } from '../shared/components/page-hero/page-hero.component';

@NgModule({
  declarations: [
    SpinnerComponent,
    SigninComponent,
    ForgetpasswordComponent,
    ResetpasswordComponent,
    VerifyComponent,
    SessionOverStateComponent,
    AuthlayoutComponent,
    ApphomelayoutComponent,
    AppinnerlayoutComponent,
    FooterinfoComponent,
    HeaderbackComponent,
    PagenotfoundComponent,
    PagenotauthorizedComponent,
    TenantsCreatePageComponent,
    ProfileEditComponent,
    UsersCreatePageComponent,
    HeadermenuComponent,
    SidebarComponent,
    ProfileComponent,
    TenantsPageComponent,
    UsersListPageComponent,
    ImpersonationModalComponent,
    TenantFormComponent,
    UserBasicInfoFormComponent,
    UserHeaderImageComponent,
    TenantListComponent,
    UserCardComponent,
    UsersListComponent,
    SalesProfileQuestionnaireComponent,
    SalesProfileSummaryCardComponent,
    LogoComponent,
    OfflineLabelComponent,
    PwaInstallButtonComponent,
    UnsyncedChangesComponent,
    ChangePasswordFormComponent,
    HomepageComponent,
    HomeMenuGridComponent,
    Office365authComponent,
    MenuComponent,
    DocumentPostComponent,
    MenuUserCardComponent,
    FolderPostComponent,
    FolderpageComponent,
    DocumenttypePostComponent,
    DocumenttypeEditpageComponent,
    DocumentEditpageComponent,
    FolderEditpageComponent,
    FolderEditformComponent,
    DocumentEditformComponent,
    DocumenttypeEditformComponent,
    DocumenttypeFromSideMenuComponent,
    AdminDocumentPageComponent,
    AdminCompaniesPageComponent,
    CompaniesEditformComponent,
    ClientsCreatePageComponent,
    AdminLocationsPageComponent,
    AdminContactsPageComponent,
    ContactsCreatePageComponent,
    LocationsEditformComponent,
    ContactsEditformComponent,
    ActiveTenantPageComponent,
    NotificationsListComponent,
    TenantInfoPageComponent,
    TenantInfoComponentComponent,
    MenuItemComponent,
    TenantHtmlFormComponent,
    TenantEdithtmlPageComponent,
    SidebarItemsComponent,
    TenantMsGraphEditPageComponent,
    TenantMsGraphEditFormComponent,
    TenantDescriptionFormComponent,
    TenantEmailTemplateComponent,
    TenantQuestionnaireComponent,
    TenantSpDescriptionComponent,
    NavbarComponent,
    TenantTagsComponent,
    TenantEmailsListPageComponent,
    TenantFoldersComponent,
    TenantTeamsComponent,
    TenantDepartmentsComponent,
    TenantChecklistPageComponent,
    ChecklistModalComponent,
  ],
  exports: [
    SidebarComponent,
    SigninComponent,
    ForgetpasswordComponent,
    ResetpasswordComponent,
    VerifyComponent,
    SessionOverStateComponent,
    AuthlayoutComponent,
    ApphomelayoutComponent,
    AppinnerlayoutComponent,
    FooterinfoComponent,
    HeaderbackComponent,
    PagenotfoundComponent,
    PagenotauthorizedComponent,
    TenantsCreatePageComponent,
    ProfileEditComponent,
    UsersCreatePageComponent,
    HeadermenuComponent,
    ProfileComponent,
    TenantsPageComponent,
    UsersListPageComponent,
    OfflineLabelComponent,
    PwaInstallButtonComponent,
    UnsyncedChangesComponent,
    DocumentPostComponent,
    ActiveTenantPageComponent,
    SidebarItemsComponent,
  ],
  imports: [
    CoreRoutingModule,
    MatCardModule,
    MatToolbarModule,
    MatButtonModule,
    MatProgressBarModule,
    MatListModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    FormsModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoRootModule,
    BaseModule,
    SplitButtonModule,
    ButtonModule,
    TableModule,
    TagModule,
    SelectModule,
    InputTextModule,
    TooltipModule,
    SelectButtonModule,
    ButtonModule,
    SplitButtonModule,
    TagModule,
    SelectModule,
    ConfirmDialogModule,
    ToastModule,
    ProgressSpinnerModule,
    CustomColorIconComponent,
    ToggleSwitchModule,
    DialogModule,
    TreeModule,
    Checkbox,
    IgntrFlameComponent,
    IgntrIconComponent,
    DashboardCardComponent,
    DashboardHeroComponent,
    DashboardTodayAgendaComponent,
    DashboardTasksSummaryComponent,
    DashboardNewsFeedComponent,
    DashboardContinueLearningComponent,
    DashboardFeaturedToolsComponent,
    DashboardGamificationComponent,
    DashboardHeaderComponent,
    BreadcrumbComponent,
    PageHeroComponent,
    GamificationToastComponent,
  ],
})
export class CoreModule {}
